import * as React from "react";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Typography,
} from "@mui/material";
import {

  Fragment,
  PopupBody,
  PopupButton,
  PopupHeader,

} from "./ModalWindow.styled";

export const ModalWindow = ({ open, onClose, header, children }) => {
 
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <PopupBody>
        <Fragment>
          <PopupHeader>
            <Box>
              <Typography variant="h1" color="text.secondary" marginLeft={1} marginTop={1}>{header}</Typography>
            </Box>
            <PopupButton aria-label="close" onClick={onClose} style={{ transform: 'scale(1.4)' }}>
              <CloseIcon sx={{ fontSize: 30 }} />
            </PopupButton>
          </PopupHeader>
          <Box
            sx={{
              p: 2,
            }}
          >
            {children}
          </Box>
        </Fragment>
      </PopupBody>
    </Modal>
  );
};
